import { render, staticRenderFns } from "./FilterCardPaginationValueField.vue?vue&type=template&id=bd4dbe5a"
import script from "./FilterCardPaginationValueField.vue?vue&type=script&lang=ts"
export * from "./FilterCardPaginationValueField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports